import Pt from 'prop-types'
import { connect } from 'react-redux'

import UserDetails from '../../components/Payment/TokenDetails'
import {
  makeSelectPaymentToken,
} from '../../redux/modules/paymentToken'

export const makeMapStateToProps = () => {
  const selectPaymentToken = makeSelectPaymentToken()

  return (state, ownProps) => ({
    token: selectPaymentToken(state, {
      uuid: ownProps.uuid,
    }),
  })
}

const WrappedPaymentToken = connect(makeMapStateToProps)(UserDetails)

WrappedPaymentToken.propTypes = {
  uuid: Pt.number.isRequired,
}

export default WrappedPaymentToken



// WEBPACK FOOTER //
// ./deps/internal-components/src/containers/Payment/TokenDetails.js